module.exports = __webpack_public_path__ + "img/H1.13e73ca8.png";